import { useRef, useState, useCallback, useEffect, useMemo } from 'react';
import Play from '@/components/ui/icons/Play';

// components
import YouTube from 'react-youtube';

const VideoBlock = ({ videoId, thumbnail }) => {
  const videoRef = useRef();
  const containerRef = useRef();
  const [isReady, setIsReady] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });

  useEffect(() => {
    if (!containerRef.current) return;

    const updateDimensions = () => {
      if (containerRef.current) {
        setDimensions({
          width: containerRef.current.offsetWidth,
          height: containerRef.current.offsetHeight
        });
      }
    };

    // Nastavit počáteční rozměry
    updateDimensions();

    // Sledovat změny velikosti kontejneru
    const resizeObserver = new ResizeObserver(updateDimensions);
    resizeObserver.observe(containerRef.current);

    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  const onReady = useCallback((event) => {
    setIsReady(true);
    videoRef.current = event.target;
  }, []);

  const onPlay = useCallback(() => {
    if (videoRef.current) {
      setIsPlaying(true);

      videoRef.current.playVideo();
    } else {
      setTimeout(() => {
        setIsPlaying(true);

        videoRef.current.playVideo();
      }, 500);
    }
  }, []);

  const onStop = useCallback(() => {
    setIsPlaying(false);
  }, []);

  const opts = useMemo(
    () => ({
      width: dimensions.width,
      height: dimensions.height,
      playerVars: {
        controls: 1,
        modestbranding: 1
      }
    }),
    [dimensions]
  );

  return (
    <div
      ref={containerRef}
      className="relative flex h-full w-full cursor-pointer items-center justify-center overflow-hidden rounded-2xl bg-black/5"
    >
      {dimensions.width > 0 && dimensions.height > 0 && (
        <div className={`absolute h-full w-full ${isPlaying || !thumbnail ? 'opacity-100' : 'opacity-0'}`}>
          <YouTube videoId={videoId} opts={opts} onReady={onReady} onEnd={onStop} />
        </div>
      )}

      <div className={`group position absolute h-full w-full ${isPlaying ? 'hidden' : 'block'}`} onClick={onPlay}>
        {thumbnail}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 transition-opacity">
          <div className="bg-brand-400 group-hover:bg-brand-500 ease flex h-20 w-20 scale-75 items-center justify-center rounded-full text-white shadow-[0_25.691px_44.042px_9.175px_rgba(254,64,17,0.15),5.505px_7.34px_20.186px_0_rgba(254,64,17,0.20)] transition duration-300 xl:scale-100 xl:group-hover:scale-105">
            <Play width={42} height={42} />
          </div>
        </div>
      </div>
    </div>
  );
};
export default VideoBlock;
